// extracted by mini-css-extract-plugin
export var active = "_kd-e";
export var blink = "_kd-f";
export var dropDownSelector = "_kd-5";
export var dropDownWrapper = "_kd-4";
export var fakeCursor = "_kd-d";
export var fontSizeButton = "_kd-7";
export var formQuillEditor = "_kd-0";
export var pressed = "_kd-g";
export var qlBlank = "_kd-1";
export var textFormattingToolbar = "_kd-2";
export var textFormattingToolbarClosed = "_kd-3";
export var textFormattingToolbarInline = "_kd-6";
export var textToolbarOption = "_kd-8";
export var toolbarCell = "_kd-a";
export var toolbarCellCollapsed = "_kd-b";
export var toolbarOptionHitArea = "_kd-c";
export var toolbarOverflow = "_kd-9";